<template>
  <div class="accordion">
    <div class="main-container">
      <div class="list-categories heading-3-bold">
        <div v-for="box in field.value.boxes"
             :class="{'accordion-link-active':box.id===selectedBox.id}"
             @click="selectBox(box)"
             class="accordion-link">
          <svg class="arrow-asset" width="28" height="25" viewBox="0 0 28 25" fill="currentColor"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.5 0.9375L27.5 11.4375C27.8125 11.75 28 12.125 28 12.5625C28 12.9375 27.8125 13.3125 27.5 13.625L16.5 24.125C15.9375 24.6875 14.9375 24.6875 14.375 24.0625C13.8125 23.5 13.8125 22.5 14.4375 21.9375L22.75 14.0625H1.5C0.625 14.0625 0 13.375 0 12.5625C0 11.6875 0.625 11.0625 1.5 11.0625H22.75L14.4375 3.125C13.8125 2.5625 13.8125 1.5625 14.375 1C14.9375 0.375 15.875 0.375 16.5 0.9375Z"
              fill="currentColor"/>
          </svg>
          <div class="accordion-title">{{ box.title }}</div>
        </div>
      </div>
      <div class="categories-info">
        <div class="asset-container">
          <img src="../../assets/4.jpg" alt="">
        </div>
        <div class="text-container">
          <div class="paragraph-1-large">{{ selectedBox.text }}</div>
          <div class="lead-1">{{ selectedBox.text2 }}</div>
          <seu-button
            :label="selectedBox.buttonName"
            :button-icon-before="arrow"
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: "Accordion",
  components: {SeuButton},
  props: {
    field: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    selectedBox: {},
    arrow: require('../../assets/icons/arrow-white-right.svg')

  }),
  methods: {
    selectBox(box) {
      this.selectedBox = box
    }
  },
  created() {
    this.selectedBox = this.field.value.boxes[0]
  }

}
</script>

<style lang="scss">
@import "Accordion.scss";
</style>
